import React, { useState } from 'react'
import { DashboardView } from './views/DashboardView'
import { RoutesView } from './views/RoutesView'
import { TimeoutsView } from './views/TimeoutsView'
import { ActivityView } from './views/ActivityView'
import { DryRunView } from './views/DryRunView'
import { HistoryView } from './views/HistoryView'
import { PlansView } from './views/PlansView'

type SubTab = 'dashboard' | 'routes' | 'timeouts' | 'plans' | 'dry-run' | 'history' | 'activity'

const SUB_TABS: Array<{ id: SubTab; label: string }> = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'routes',    label: 'Routes' },
  { id: 'timeouts',  label: 'Timeouts' },
  { id: 'plans',     label: 'Plans' },
  { id: 'dry-run',   label: 'Dry-Run' },
  { id: 'history',   label: 'Affaire History' },
  { id: 'activity',  label: 'Activity log' }
]

export const LeaV3Tab: React.FC = () => {
  const [active, setActive] = useState<SubTab>('dashboard')

  return (
    <div className="p-6 space-y-6 bg-gray-50 min-h-screen">
      <header>
        <h1 className="text-2xl font-bold text-gray-800">Léa V3</h1>
        <p className="text-sm text-gray-500 mt-1">
          Console admin pour le nouveau scheduler V3 — routing matrix, ladder progression, timeouts configurables.
        </p>
      </header>

      <nav className="flex gap-1 border-b border-gray-200">
        {SUB_TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setActive(t.id)}
            className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
              active === t.id
                ? 'border-[#ef5343] text-[#ef5343]'
                : 'border-transparent text-gray-500 hover:text-gray-800'
            }`}
          >
            {t.label}
          </button>
        ))}
      </nav>

      <main>
        {active === 'dashboard' && <DashboardView />}
        {active === 'routes' && <RoutesView />}
        {active === 'timeouts' && <TimeoutsView />}
        {active === 'plans' && <PlansView />}
        {active === 'dry-run' && <DryRunView />}
        {active === 'history' && <HistoryView />}
        {active === 'activity' && <ActivityView />}
      </main>
    </div>
  )
}
